module.exports = __webpack_public_path__ + "img/schysst_elhandel.4df85605.jpg";